import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ReadRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkGuard } from '../guards/retailer-network.guard';
import { RetailerNetworkTobaccoPerformanceGuard } from '../guards/retailer-network-tobacco-performance.guard';

type RetailerNetworkTobaccoPerformanceDetailsPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkTobaccoPerformanceDetailsPageGuard = ({
  children,
}: RetailerNetworkTobaccoPerformanceDetailsPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <RetailerNetworkTobaccoPerformanceGuard>
      <RetailerNetworkGuard policyWithParams={ReadRetailerNetwork({ uuid: networkId })}>
        {children}
      </RetailerNetworkGuard>
    </RetailerNetworkTobaccoPerformanceGuard>
  );
};
